import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';

const AutoCloseAlert = ({ 
  severity, 
  message, 
  onClose, 
  autoCloseDelay = 5000, // 5 seconds default
  show = false 
}) => {
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    setIsVisible(show);
    
    if (show && autoCloseDelay > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) {
          onClose();
        }
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [show, autoCloseDelay, onClose]);

  if (!isVisible) {
    return null;
  }

  return (
    <Alert 
      severity={severity} 
      sx={{ mb: 2 }} 
      onClose={() => {
        setIsVisible(false);
        if (onClose) {
          onClose();
        }
      }}
    >
      {message}
    </Alert>
  );
};

export default AutoCloseAlert; 